import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconInfo } from "../../icons/IconInfo.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import { Tooltip } from "../tooltip/Tooltip.js";
import TooltipIndicator_module from "./TooltipIndicator.module.js";
const TooltipIndicator = /*#__PURE__*/ forwardRef(({ iconProps, size, tabIndex, ...props }, ref)=>/*#__PURE__*/ jsx(Tooltip, {
        testId: "tooltip",
        attachAs: 'label',
        ...props,
        children: /*#__PURE__*/ jsx(IconInfo, {
            tabIndex: tabIndex ?? 0,
            size: size,
            ...iconProps,
            className: combineClasses(TooltipIndicator_module.tooltipIndicator, iconProps?.className),
            ref: ref
        })
    }));
TooltipIndicator.displayName = 'TooltipIndicator';
export { TooltipIndicator };
